Ext.define('SA.data.BarChartView', {
    alias: 'view.barChart',
    extend: 'SA.data.ReportView',

    mixins: {
        locations: 'SA.data.mixin.ManyLocations'
    },

    statics: {
        create({project, censusRelease, name, locationItems, attributes}) {
            var data = {
                type: 'barChart',
                attribute: attributes.filter(id => this.supportsAttribute(id))[0] || null,
                buildingBlocksCensusRelease: censusRelease,
                filterVisibility: 'strikeout',
                locationItems,
                name,
                sortDirection: 'desc'
            };

            return new SA.data.BarChartView({project, data});
        },

        supportsAttribute(attribute) {
            return SA.data.AttributesCache.isPolygonAttribute(attribute);
        }
    },

    addAttributeImpl(attribute) {
        this.data.attribute = attribute;

        this.project.addAttribute(attribute);
    },

    addLocationImpl(location) {
        this.mixins.locations.addLocationImpl.call(this, location);

        this.project.addLocation(location);
    },

    createController() {
        return new SA.BarChartController(this);
    },

    createDataMap() {
        return new SA.data.DataMap({
            country: this.getCountry()
        });
    },

    getAttribute() {
        return this.data.attribute;
    },

    getAttributes() {
        var attribute = this.getAttribute();

        return attribute ? [attribute] : [];
    },

    getReportData(cfg) {
        cfg = cfg || {};

        var map = this.getDataMap();

        map.ensure({
            attributes: this.getAttributes(),
            locations: this.getQueryLocations(),

            fn: cfg.fn,
            scope: cfg.scope
        });

        return map.getData();
    },

    getSortDirection() {
        return this.data.sortDirection;
    },

    hasDescSortDirection() {
        return this.getSortDirection() === 'desc';
    },

    onCustomLocationUpdateImpl(location) {
        this.getDataMap().removeLocation(SA.data.LocationsCache.normalizeLocation(location));
    },

    removeAttributeImpl(attribute) {
        if (attribute === this.data.attribute) {
            this.data.attribute = null;
        }

        this.callParent([attribute]);
    },

    setSortDirection(direction) {
        var previousDirection = this.data.sortDirection;

        if (direction !== previousDirection) {
            this.set('sortDirection', direction);
            this.fireEvent('change:sortDirection', this);
        }
    }
});
